import type { WarrantyComparator } from '@policyvision/contracts';

import { TableCell, TableRow } from '@/common/components/ui/table';
import { VariationBadge } from '@/common/components/ui/variation-badge';
import { useFormatCurrency } from '@/common/hooks/useFormatCurrency';

interface ComparatorRowProps {
  row: WarrantyComparator;
  isLast: boolean;
}

const CELL_CLASS = 'bg-white border-r border-b text-right';

const ComparatorRow = ({ row, isLast }: ComparatorRowProps) => {
  const lastBorderClass = isLast ? 'border-b-warm-gray-200' : '';

  const { formatCurrency } = useFormatCurrency();

  return (
    <TableRow>
      <TableCell
        className={`${lastBorderClass} whitespace-normal bg-white border-l border-b border-l-warm-gray-200`}
      >
        {row.label}
      </TableCell>
      <TableCell className={`${lastBorderClass} ${CELL_CLASS} border-l`}>
        {formatCurrency(row.lastYear.amount)}
      </TableCell>
      <TableCell className={`${lastBorderClass} ${CELL_CLASS}`}>
        {formatCurrency(row.lastYear.rate)}
      </TableCell>
      <TableCell className={`${lastBorderClass} ${CELL_CLASS} border-r-2`}>
        {formatCurrency(row.lastYear.premium)}
      </TableCell>
      <TableCell className={`${lastBorderClass} ${CELL_CLASS}`}>
        {formatCurrency(row.currentYear.amount)}
      </TableCell>
      <TableCell className={`${lastBorderClass} ${CELL_CLASS}`}>
        {formatCurrency(row.currentYear.rate)}
      </TableCell>
      <TableCell className={`${lastBorderClass} ${CELL_CLASS} border-r-2`}>
        {formatCurrency(row.currentYear.premium)}
      </TableCell>
      <TableCell className={`${lastBorderClass} ${CELL_CLASS} text-center`}>
        <VariationBadge value={row.variation.amount} />
      </TableCell>
      <TableCell
        className={`${lastBorderClass} ${CELL_CLASS} border-r-warm-gray-200 text-center`}
      >
        <VariationBadge value={row.variation.rate} />
      </TableCell>
    </TableRow>
  );
};

export default ComparatorRow;
